import { DEFAULTS_VIEWER } from "./defaults.js";
import { HTML_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/nodeViewRenderers-loadable.js";
const pluginHtml = (config) => {
  return {
    config: { ...DEFAULTS_VIEWER, ...config },
    type: HTML_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginHtml
};
//# sourceMappingURL=viewer-loadable.js.map
